import React from 'react';
import { Skeleton } from 'antd';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../redux/store';
import { SectionContent, SectionTitle, SectionText, EmptyState, EmptyStateText } from './Styles';
import { EMPTY_STATE_MESSAGES } from './constants';

const DailyOperationsSection: React.FC = () => {
  const { dailyOperations, loading } = useSelector(
    (state: RootState) => state.managerReports
  );

  if (loading.dailyOperations) {
    return (
      <SectionContent>
        <Skeleton active paragraph={{ rows: 4 }} />
      </SectionContent>
    );
  }

  if (!dailyOperations) {
    return (
      <EmptyState>
        <EmptyStateText>{EMPTY_STATE_MESSAGES.DAILY_OPERATIONS}</EmptyStateText>
      </EmptyState>
    );
  }

  return (
    <SectionContent>
      <SectionTitle>Daily Operations Details</SectionTitle>
      <SectionText>
        Detailed report on daily operations including order processing, completion rates,
        average order times, and operational efficiency metrics.
      </SectionText>
      {/* Add more detailed content here when API data is available */}
    </SectionContent>
  );
};

export default React.memo(DailyOperationsSection);
